import gql from "graphql-tag";

export const MY_TENANT_DASHBOARD_QUERY = gql`
    query {
        myTenantDashboard {
            id
            tenant {
                id
                name
            }
            totalPlants
            totalProducts
            totalGrowthTasks
            totalInventory
            totalOrders
            totalPicklists
            totalGreenhouseSpaceM2
            totalGreenhouseUsedSpaceM2
            totalGreenhouseUsedRate
            totalSuppliers
            totalCustomers
            totalGroups
            totalUsers
        }
    }
`;

// fragment
export const TENANT_USER_GROUP_FRAGMENT = gql`
    fragment tenantUserGroupNode on TenantUserGroupNode {
        id
        name
        group {
            id
            userSet {
                totalCount
            }
            permissions {
                totalCount
            }
        }
    }
`;

// create
export const CREAT_TENANT_USER_GROUP_MUTATION = gql`
    mutation createTenantUserGroup($input: CreateTenantUserGroupInput!) {
        createTenantUserGroup(input: $input) {
            tenantUserGroup {
                ...tenantUserGroupNode
            }
        }
    }
    ${TENANT_USER_GROUP_FRAGMENT}
`;

// update
export const UPDATE_TENANT_USER_GROUP_MUTATION = gql`
    mutation updateTenantUserGroup($input: UpdateTenantUserGroupInput!) {
        updateTenantUserGroup(input: $input) {
            tenantUserGroup {
                ...tenantUserGroupNode
            }
        }
    }
    ${TENANT_USER_GROUP_FRAGMENT}
`;

// delete
export const DELETE_TENANT_USER_GROUP_MUTATION = gql`
    mutation deleteTenantUserGroup($input: DeleteTenantUserGroupInput!) {
        deleteTenantUserGroup(input: $input) {
            tenantUserGroup {
                ...tenantUserGroupNode
            }
        }
    }
    ${TENANT_USER_GROUP_FRAGMENT}
`;
